import { useState } from 'react'
import * as Icons from 'lucide-react'

/* Gecureerde set van team-relevante iconen. Genoeg om jezelf te kunnen
   onderscheiden zonder de user in een oneindige lijst van 1500 lucide-icons
   te gooien. Naam is exact de lucide-react component-naam. */
const KEUZE = [
  'Users', 'User', 'Shield', 'ShieldCheck', 'Sword', 'Swords',
  'Crown', 'Trophy', 'Medal', 'Award', 'Flag', 'Rocket',
  'Flame', 'Zap', 'Skull', 'Ghost', 'Bomb', 'Target',
  'Gamepad2', 'Joystick', 'Dices', 'Puzzle',
  'Star', 'Sparkles', 'Sun', 'Moon', 'Cloud',
  'Bird', 'Cat', 'Dog', 'Rabbit', 'Rat', 'Snail', 'Fish', 'Bug',
  'Anchor', 'Axe', 'Mountain', 'Diamond', 'Gem', 'Cherry', 'Beer',
  'Palette', 'Music', 'Radio', 'Camera',
]

export default function IconPicker({ value, onChange, kleur = '#B4FF39' }) {
  const [open, setOpen] = useState(false)
  const [zoek, setZoek] = useState('')
  const HuidigIcon = Icons[value] || Icons.Users

  const zichtbaar = zoek
    ? KEUZE.filter(k => k.toLowerCase().includes(zoek.toLowerCase()))
    : KEUZE

  return (
    <div className="relative">
      <button type="button" onClick={() => setOpen(o => !o)}
              className="w-full flex items-center gap-2 rounded-[4px] border border-border bg-background px-3 py-2 hover:border-acid/60 transition-colors">
        <span className="h-8 w-8 rounded-[4px] grid place-items-center shrink-0"
              style={{ background: `${kleur}22` }}>
          <HuidigIcon className="h-4 w-4" style={{ color: kleur }} />
        </span>
        <span className="text-sm font-mono flex-1 text-left">{value || 'Users'}</span>
        <Icons.ChevronDown className="h-4 w-4 text-muted-foreground" />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute z-50 mt-1 w-[22rem] max-w-[calc(100vw-2rem)] rounded-[6px] border border-border bg-card shadow-xl p-2">
            <div className="relative mb-2">
              <Icons.Search className="h-3.5 w-3.5 absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <input type="text" value={zoek} onChange={e => setZoek(e.target.value)} autoFocus
                     placeholder="Zoek…" className="w-full rounded-[4px] border border-border bg-background pl-7 pr-2 py-1 text-xs" />
            </div>
            <div className="grid grid-cols-8 gap-1 max-h-[16rem] overflow-y-auto">
              {zichtbaar.map(naam => {
                const Icon = Icons[naam]
                if (!Icon) return null
                const gekozen = naam === value
                return (
                  <button key={naam} type="button"
                          onClick={() => { onChange(naam); setOpen(false); setZoek('') }}
                          title={naam}
                          className="h-10 w-10 rounded-[4px] border grid place-items-center transition-colors hover:border-acid"
                          style={{
                            borderColor: gekozen ? kleur : 'transparent',
                            background: gekozen ? `${kleur}22` : 'transparent',
                          }}>
                    <Icon className="h-4 w-4" style={{ color: gekozen ? kleur : undefined }} />
                  </button>
                )
              })}
            </div>
          </div>
        </>
      )}
    </div>
  )
}
